import React from "react";
import { Page } from "../activities/AppPage";
import { openExternalUrl } from "../external_link";
import { STRINGS } from "../strings";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { translate } from "../translate";
import { AppList, AppListItem } from "./Generic/AppList";
import TrailingChevron from "./Generic/TrailingChevron/TrailingChevron";
import GenericSettingsScreen from "./GenericSettingsScreen";

interface Props {
  caregiver: AppCaregiver;
  shouldShowMyVirtualId: boolean;
  shouldShowMedflytHandbook: boolean;
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
}

const InformationCenterScreen = (props: Props) => {
  return (
    <GenericSettingsScreen
      title={translate(STRINGS.INFORMATION_CENTER)}
      onClickGoBack={props.onClickGoBack}
    >
      <AppList bordered={true}>
        {props.shouldShowMyVirtualId ? (
          <AppListItem
            title={translate(STRINGS.VIRTUAL_ID_CARD)}
            trailing={<TrailingChevron />}
            onClick={() => props.onRequestNavigate({ type: "MyVirtualId" })}
          />
        ) : null}
        {props.shouldShowMedflytHandbook ? (
          <AppListItem
            title={translate(STRINGS.AGENCY_HANDBOOK)}
            trailing={<TrailingChevron />}
            onClick={() =>
              props.onRequestNavigate({
                type: "DocumentDownload",
                documentType: "MedflytAgencyHandbook",
              })
            }
          />
        ) : null}
        {props.caregiver.isCaregiverOfMedFlyt ? (
          <>
            <AppListItem
              title={translate(STRINGS.IMPORTANT_INFORMATION)}
              trailing={<TrailingChevron />}
              onClick={() => props.onRequestNavigate({ type: "ImportantInformation" })}
            />
            <AppListItem
              title={translate(STRINGS.MEDFLYT_AT_HOME_BENEFITS)}
              trailing={<TrailingChevron />}
              onClick={() =>
                props.onRequestNavigate({
                  type: "DocumentDownload",
                  documentType: "MedflytAgencyBenefits",
                })
              }
            />
            <AppListItem
              title={translate(STRINGS.MEC_WAIVER_INFORMATION)}
              trailing={<TrailingChevron />}
              onClick={() =>
                props.onRequestNavigate({
                  type: "DocumentDownload",
                  documentType: "MECWaiverInformation",
                })
              }
            />
          </>
        ) : null}
        <AppListItem
          title={translate(STRINGS.TERMS_OF_USE)}
          trailing={<TrailingChevron />}
          onClick={() => openExternalUrl("http://www.medflyt.com/terms")}
        />
        <AppListItem
          title={translate(STRINGS.PRIVACY_POLICY)}
          trailing={<TrailingChevron />}
          onClick={() => openExternalUrl("http://www.medflyt.com/privacy")}
        />
      </AppList>
    </GenericSettingsScreen>
  );
};

export default InformationCenterScreen;
